export const workoutsConstants = {
    WORKOUTS_ALL_REQUEST: "WORKOUTS_ALL_REQUEST",
    WORKOUTS_ALL_SUCCESS: "WORKOUT_ALL_SUCCESS",
    WORKOUTS_ALL_FAILURE: "WORKOUTS_ALL_FAILURE",

};